import { createFileRoute, redirect } from "@tanstack/react-router";

/** Seit dem Rundgang vom 12.09.2026 ist das Board eine Ansicht der Projekte — alte Links laufen weiter. */
export const Route = createFileRoute("/_angemeldet/_mitarbeiter/produktionen")({
	beforeLoad: () => {
		throw redirect({ to: "/projekte", search: { ansicht: "board" }, replace: true });
	},
});
